import { getMiddleCenterBias } from '@glideapps/glide-data-grid';
import type { GridCell, Rectangle, Theme } from '@glideapps/glide-data-grid';

const GAP = 6;

/**
 * Called after the grid has drawn a text cell: sets what the text needs said
 * about it (a cheque's "(Dealroom)", "(est. from 7 rounds)") just after it, in
 * the hint colour, clipped to the cell so a narrow column loses the suffix
 * before the figures.
 */
export function paintFaintSuffix(
  {
    ctx,
    theme,
    rect,
    cell,
  }: {
    ctx: CanvasRenderingContext2D;
    theme: Theme;
    rect: Rectangle;
    cell: GridCell;
  },
  suffix: string,
): void {
  if (suffix === '' || !('displayData' in cell) || typeof cell.displayData !== 'string') return;
  ctx.save();
  ctx.beginPath();
  ctx.rect(rect.x, rect.y, rect.width, rect.height);
  ctx.clip();
  const font = `${theme.baseFontStyle} ${theme.fontFamily}`;
  ctx.font = font;
  ctx.textBaseline = 'middle';
  ctx.fillStyle = theme.textLight;
  const rangeWidth = ctx.measureText(cell.displayData).width;
  const x = rect.x + theme.cellHorizontalPadding + rangeWidth + GAP;
  ctx.fillText(suffix, x, rect.y + rect.height / 2 + getMiddleCenterBias(ctx, font));
  ctx.restore();
}
